module.exports = __webpack_public_path__ + "static/chrome-store-img-30b36b94a9141226417371d8f7d6ebfc.svg";